/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_Misa_Template_Multi_VatInputs */

const vi_invoice_misa_template_multi_vat = /** @type {(inputs: Invoice_Misa_Template_Multi_VatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhiều mức VAT`)
};

/**

* @param {Invoice_Misa_Template_Multi_VatInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const invoice_misa_template_multi_vat = /** @type {((inputs?: Invoice_Misa_Template_Multi_VatInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_Misa_Template_Multi_VatInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_invoice_misa_template_multi_vat(inputs)
});